export default __webpack_public_path__ + "static/media/lobby_play.7fe128f2.svg";